import React from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import ClockIcon from "react-icons/lib/fa/clock-o";
import Footer from "../layouts/footer";
import MarkdownPage from "../components/MarkdownPage";

import { format } from "date-fns";

const PostTemplate = ({ data }) => {
  console.log(data);
  const { markdownRemark: post } = data;

  return (
    <div className="single-post page-wrap">
      <Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
      <div className="post-card">
        <MarkdownPage
          authors={[{ frontmatter: { name: "Aaron Ong", url: "Aaron Ong" } }]}
          // createLink={createLinkBlog}
          date={post.frontmatter.date}
          // location={{ pathname: "Singapore" }}
          ogDescription={post.excerpt}
          markdownRemark={post}
          // sectionList={toSectionList(data.allMarkdownRemark)}
          titlePostfix=" - React Blog"
        />
        {/* <h1 className="post-title">{post.frontmatter.title}</h1>
        <div className="divider" />
        <div className="date-wrap">
          <ClockIcon />
          <div className="date">
            {format(new Date(post.frontmatter.date), "MMM DD, YYYY")}
          </div>
        </div>
        <div
          className="post-content"
          dangerouslySetInnerHTML={{ __html: post.html }}
        /> */}
        <Link to="/blog" className="back-to-blog">
          Back to Blog
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default PostTemplate;

export const pageQuery = graphql`
  query BlogPostByPath($id: String!) {
    markdownRemark(frontmatter: { path: { eq: $id } }) {
      excerpt(pruneLength: 250)
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.js